import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullCloud1 extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={90} width={128}>
        <g fill="none" fillRule="evenodd" fillOpacity="0.2">
          <g transform="translate(0 -165)" fill="#EAF7FC">
            <g transform="translate(-18 44)">
              <g transform="translate(0 68)">
                <path d="M17.0435409,103.766051 L20.6210255,103.766051 C20.2430816,102.237474 20.0238164,100.639679 20.0238164,98.9813174 C20.0238164,88.8162824 27.6000057,80.5763888 36.9476269,80.5763888 C40.3433523,80.5763888 43.5010595,81.6766756 46.1509947,83.548461 C48.5758946,66.1789268 60.2820592,53 74.3669625,53 C89.4342316,53 101.777996,68.0781112 102.950776,87.2401179 C104.753944,86.0489818 106.770607,85.3611222 108.914213,85.3611222 C116.431258,85.3611222 122.525965,93.6010158 122.525965,103.766051 L128.242728,103.766051 C137.616314,103.766051 145.286268,112.279935 145.286268,122.687235 L145.286268,124.078816 C145.286268,134.486116 137.616314,143 128.242728,143 L17.0435409,143 C7.66995402,143 0,134.486116 0,124.078816 L0,122.687235 C0,112.279935 7.66995402,103.766051 17.0435409,103.766051" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullCloud1.displayName = "NullCloud1";
NullCloud1.vstuiName = "Icon";

export default NullCloud1;
